import React, { useState, useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function ProviderDetails({ providerId }) {
  const [provider, setProvider] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (providerId) {
      fetchProviderDetails();
    }
  }, [providerId]);

  const fetchProviderDetails = async () => {
    try {
      console.log('Fetching provider:', providerId);
      console.log('API URL:', `${API_URL}/providers/${providerId}`);

      const response = await fetch(`${API_URL}/providers/${providerId}`);
      console.log('Response status:', response.status);

      if (response.ok) {
        const data = await response.json();
        console.log('Provider data:', data);
        setProvider(data);
      } else {
        const errorText = await response.text();
        console.error('Error response:', errorText);
        setError(`Provider not found (Status: ${response.status})`);
      }
    } catch (error) {
      console.error('Error fetching provider details:', error);
      setError(`Failed to load provider details: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '400px',
        fontSize: '18px',
        color: '#555'
      }}>
        Loading provider details...
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '400px',
        fontSize: '18px',
        color: '#e74c3c'
      }}>
        {error}
      </div>
    );
  }

  if (!provider) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '400px',
        fontSize: '18px',
        color: '#e74c3c'
      }}>
        Provider not found
      </div>
    );
  }

  const isMobile = window.innerWidth <= 768;

  return (
    <div style={{
      maxWidth: '900px',
      margin: '0 auto',
      padding: isMobile ? '15px' : '30px'
    }}>
      {/* Header with Verification Badge */}
      <div style={{
        backgroundColor: '#e8f5e9',
        border: '3px solid #27ae60',
        borderRadius: '10px',
        padding: isMobile ? '20px 15px' : '30px',
        marginBottom: isMobile ? '20px' : '30px',
        textAlign: 'center'
      }}>
        <div style={{
          fontSize: isMobile ? '36px' : '48px',
          marginBottom: '15px'
        }}>
          ✓
        </div>
        <h1 style={{
          color: '#27ae60',
          margin: '0 0 10px 0',
          fontSize: isMobile ? '22px' : '32px'
        }}>
          Verified Provider
        </h1>
        <p style={{
          color: '#555',
          fontSize: isMobile ? '14px' : '16px',
          margin: '10px 0'
        }}>
          This provider has been verified by GLOBAL RESEARCH ORGANISATION
        </p>
        {provider.barcodeId && (
          <div style={{
            marginTop: '15px',
            fontSize: isMobile ? '14px' : '18px',
            fontWeight: 'bold',
            color: '#2c3e50',
            fontFamily: 'monospace',
            letterSpacing: '1px',
            wordBreak: 'break-all'
          }}>
            ID: {provider.barcodeId}
          </div>
        )}
      </div>

      {/* Provider Information */}
      <div style={{
        backgroundColor: 'white',
        border: '2px solid #ddd',
        borderRadius: '10px',
        padding: isMobile ? '20px 15px' : '30px',
        marginBottom: isMobile ? '20px' : '30px'
      }}>
        <h2 style={{
          color: '#2c3e50',
          marginTop: 0,
          marginBottom: '20px',
          fontSize: isMobile ? '20px' : '28px',
          borderBottom: '3px solid #3498db',
          paddingBottom: '12px',
          wordBreak: 'break-word'
        }}>
          {provider.name}
        </h2>

        <div style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: isMobile ? '15px' : '20px',
          marginBottom: '25px'
        }}>
          <div>
            <h3 style={{ color: '#555', fontSize: '14px', marginBottom: '8px', textTransform: 'uppercase' }}>
              Specialization
            </h3>
            <p style={{ color: '#2c3e50', fontSize: '16px', margin: 0, fontWeight: '500' }}>
              {provider.specialization}
            </p>
          </div>

          <div>
            <h3 style={{ color: '#555', fontSize: '14px', marginBottom: '8px', textTransform: 'uppercase' }}>
              Location
            </h3>
            <p style={{ color: '#2c3e50', fontSize: '16px', margin: 0, fontWeight: '500' }}>
              {provider.location}
            </p>
          </div>

          <div>
            <h3 style={{ color: '#555', fontSize: '14px', marginBottom: '8px', textTransform: 'uppercase' }}>
              Founded
            </h3>
            <p style={{ color: '#2c3e50', fontSize: '16px', margin: 0, fontWeight: '500' }}>
              {provider.founded}
            </p>
          </div>

          <div>
            <h3 style={{ color: '#555', fontSize: '14px', marginBottom: '8px', textTransform: 'uppercase' }}>
              Experience
            </h3>
            <p style={{ color: '#2c3e50', fontSize: '16px', margin: 0, fontWeight: '500' }}>
              {provider.completedProjects}
            </p>
          </div>

          <div>
            <h3 style={{ color: '#555', fontSize: '14px', marginBottom: '8px', textTransform: 'uppercase' }}>
              Status
            </h3>
            <p style={{ color: '#27ae60', fontSize: '16px', margin: 0, fontWeight: 'bold' }}>
              {provider.status}
            </p>
          </div>

          {provider.verifiedDate && (
            <div>
              <h3 style={{ color: '#555', fontSize: '14px', marginBottom: '8px', textTransform: 'uppercase' }}>
                Verified Date
              </h3>
              <p style={{ color: '#2c3e50', fontSize: '16px', margin: 0, fontWeight: '500' }}>
                {provider.verifiedDate}
              </p>
            </div>
          )}
        </div>

        {/* Contact Information */}
        <div style={{
          backgroundColor: '#f8f9fa',
          padding: '20px',
          borderRadius: '8px',
          marginTop: '25px'
        }}>
          <h3 style={{
            color: '#2c3e50',
            marginTop: 0,
            marginBottom: '15px',
            fontSize: '18px'
          }}>
            Contact Information
          </h3>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '15px'
          }}>
            <div>
              <strong style={{ color: '#555' }}>Email:</strong>
              <br />
              <a href={`mailto:${provider.email}`} style={{ color: '#3498db', textDecoration: 'none' }}>
                {provider.email}
              </a>
            </div>
            <div>
              <strong style={{ color: '#555' }}>Phone:</strong>
              <br />
              <span style={{ color: '#2c3e50' }}>{provider.phone}</span>
            </div>
            {provider.website && (
              <div>
                <strong style={{ color: '#555' }}>Website:</strong>
                <br />
                <a href={provider.website} target="_blank" rel="noopener noreferrer" style={{ color: '#3498db', textDecoration: 'none' }}>
                  {provider.website}
                </a>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Trust Badge */}
      <div style={{
        backgroundColor: '#f8f9fa',
        border: '2px solid #ddd',
        borderRadius: '10px',
        padding: '25px',
        textAlign: 'center'
      }}>
        <p style={{
          color: '#555',
          fontSize: '14px',
          margin: 0,
          lineHeight: '1.8'
        }}>
          This provider has been thoroughly verified by GLOBAL RESEARCH ORGANISATION and meets our standards for quality, ethics, and professional conduct. All information displayed has been validated during the verification process.
        </p>
        <p style={{
          color: '#27ae60',
          fontSize: '16px',
          fontWeight: 'bold',
          margin: '15px 0 0 0'
        }}>
          Your Trusted Partner in Research Integrity
        </p>
      </div>
    </div>
  );
}

export default ProviderDetails;
